import { stVars } from '../Foundation/stylable/spacing.st.css';

export const DIRECTION = {
  horizontal: 'horizontal',
  vertical: 'vertical',
} as const;

export const HORIZONTAL_ALIGNMENT = {
  left: 'left',
  center: 'center',
  right: 'right',
  'space-between': 'space-between',
} as const;

export const VERTICAL_ALIGNMENT = {
  top: 'top',
  middle: 'middle',
  bottom: 'bottom',
  'space-between': 'space-between',
} as const;

export const SPACING = {
  tiny: stVars.SP1,
  small: stVars.SP2,
  medium: stVars.SP3,
  large: stVars.SP4,
} as const;
